/** Public URLs use a trailing slash. Admin and external URLs are left alone. */
export function publicPath(path: string) {
  if (!path || path === '/') return '/'
  if (/^(https?:|mailto:|tel:|#)/i.test(path)) return path
  const match = path.match(/^([^?#]*)(.*)$/)
  const pathname = match?.[1] || path
  const rest = match?.[2] || ''
  if (pathname.startsWith('/admin')) return `${pathname}${rest}`
  const slashed = pathname.endsWith('/') ? pathname : `${pathname}/`
  return `${slashed}${rest}`
}

export function storyPath(slug: string) {
  return publicPath(`/stories/${slug}`)
}

export function authorPath(slug: string) {
  return publicPath(`/author/${slug}`)
}

export function stripSlash(pathname: string) {
  if (pathname === '/') return '/'
  return pathname.replace(/\/+$/, '')
}
